import { BadgeProps } from "components/badges/Badges";
import { SvgIModelJs } from "components/icons/SvgIModeljs";
import { Link } from "react-router-dom";
import { routeTo } from "router";
import { sandboxApi } from "services/sandbox-api/api";
import { CodeShareMetadata } from "types";
import { Badge, Text, Tile } from "@itwin/itwinui-react";
import { Description } from "../description/Description";
import { ShareStats } from "../share-stats/ShareStats";
import styles from "./SandboxTile.module.css";
import { VersionBadge } from "./VersionBadge";

export interface SandboxTileProps {
  sandbox: CodeShareMetadata;
  isSelected?: boolean;
  isActionable?: boolean;
  showUserName?: boolean;
  showDescription?: boolean;
  showStats?: boolean;
  badges?: BadgeProps[];
  onClick?: (sandbox: CodeShareMetadata) => void;
  onTagClick?: (tag: string) => void;
  onUsernameClick?: (username: string) => void;
}

export const SandboxTile = (options: SandboxTileProps) => {
  const {
    sandbox,
    isSelected,
    isActionable,
    showUserName = true,
    showDescription = true,
    showStats,
    badges,
    onClick = () => { },
  } = options;
  const { data: thumbnail, isLoading } = sandboxApi.useThumbnailQuery({ userId: sandbox.userId, codeshareId: sandbox.id, isAvailable: sandbox.isThumbnailAdded });

  return (
    <div onClick={() => onClick(sandbox)}>
      <Tile
        className={["iui-actionable", styles.tile, !showStats ? styles.withoutMeta : ""].join(" ")}
        name={<span data-test="atp-sandboxtile-name">{sandbox.name}</span>}
        description={<>
          {showUserName && sandbox.username && <>by <Link to={routeTo.search(sandbox.username)} className="iui-anchor">{sandbox.username}</Link></>}
          {<VersionBadge version={sandbox.itwinVersion} />}
          {showDescription && <Description description={sandbox.description} className={styles.description} />}
        </>}
        isActionable={isActionable}
        isSelected={isSelected}
        badge={badges?.map((badge, index) =>
          <Badge key={index} backgroundColor={badge.color} className={styles.badge}>{badge.label}</Badge>
        )}
        thumbnail={isLoading ? <Text isSkeleton className={styles.skeletonLoading} /> : thumbnail || <SvgIModelJs />}
        metadata={showStats ? <ShareStats likes={sandbox.likes} views={sandbox.views} forks={sandbox.forks} /> : undefined}
        data-test = "atp-sandbox-tile"
      />
    </div>
  )
}